import u from "./ui.module.css";

export default function Tabs({ items, active, onChange }) {
  return (
    <div className={u.tabs} role="tablist">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={active === item.id}
          className={`${u.tab} ${active === item.id ? u.tabActive : ""}`}
          onClick={() => onChange(item.id)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
